import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useAppDispatch } from "src/hooks/redux";
import { resolveApplicantScreeningIssue } from "src/services/AdminDashService";

interface ResolveAlertModalProps {
  showModal: boolean;
  setShowModal: (val: boolean) => void;
  applicant: {
    fullName: string;
    applicantId?: number;
    issueId: number;
  };
  onConfirmResolve: (wasSuccesful: boolean) => void;
  onCancel: () => void;
}

const ResolveAlertModal = ({
  showModal,
  applicant,
  onConfirmResolve,
  onCancel,
}: ResolveAlertModalProps) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const dispatch = useAppDispatch();

  const handleResolve = async () => {
    setShowSpinner(true);

    try {
      const wasSuccessful = await dispatch(
        resolveApplicantScreeningIssue(
          String(applicant?.applicantId!),
          applicant.issueId
        )
      );

      onConfirmResolve(wasSuccessful);
    } catch (err) {
      console.error("Failed to resolve issue:", err);
      onConfirmResolve(false);
    } finally {
      setShowSpinner(false);
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showModal}
      className="resolve-alert-modal"
    >
      <Modal.Header className="border-bottom-0" closeButton onHide={onCancel}>
        <Modal.Title
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            lineHeight: "1", // tighter line spacing
          }}
        >
          <span
            className="cancel-icon"
            style={{
              display: "inline-block",
              verticalAlign: "middle",
            }}
          >
            !
          </span>
          <span
            style={{
              fontWeight: 600,
              fontSize: "15px",
              lineHeight: "1",
              verticalAlign: "middle",
            }}
          >
            Resolve Alert
          </span>
          <span
            style={{
              fontSize: "14px",
              color: "#6c757d",
              lineHeight: "1",
              verticalAlign: "middle",
            }}
          >
            for {applicant?.fullName}?
          </span>
        </Modal.Title>
      </Modal.Header>
      <hr style={{ margin: 0, borderTop: "2px solid #DCDDDF" }} />
      <Modal.Body>
        <div className="details block-labels mt-0">
          <p className="mb-3">
            By clicking the Resolve button below,
            <strong>
              {" "}
              you are confirming that you have taken all appropriate actions to
              resolve this alert.
            </strong>
          </p>
          <p>The applicant(s) will be notified once all alerts are resolved.</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0">
        <Button className="cancel-btn" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          className="resolve-btn"
          onClick={handleResolve}
          disabled={showSpinner}
        >
          {showSpinner && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
          )}
          {showSpinner ? "Resolving..." : "Resolve Alert"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResolveAlertModal;
